<template>
    <div>
        <div class="banner">
            <div class="headerReplacementDebtInfo"></div>
            <div class="banner-text">
                <b>{{ $t('debtInfo.pageTitle') }}</b>
                <div class="breadcrumb">
                    <span><router-link to="/" class="pe-auto">{{ $t('debtInfo.breadcrumbHome') }}</router-link></span>
                    <span class="separator"></span>
                    <span>{{ $t('debtInfo.pageTitle') }}</span>
                    <span class="separator"></span>
                    <span><b>{{ $t('debtInfo.pageTitle') }}</b></span>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="TabMenu">
                <DebtInfoTabMenu />
            </div>
            <div class="table-responsive">
                <table class="table mt-3 mb-5">
                    <thead>
                        <tr class="table-secondary text-center">
                            <th scope="col"><b>{{ $t('debtInfo.table.symbol') }}</b></th>
                            <th scope="col"><b>{{ $t('debtInfo.table.issuedSize') }}</b></th>
                            <th scope="col"><b>{{ $t('debtInfo.table.outstanding') }}</b></th>
                            <th scope="col"><b>{{ $t('debtInfo.table.issueDate') }}</b></th>
                            <th scope="col"><b>{{ $t('debtInfo.table.maturityDate') }}</b></th>
                            <th scope="col"><b>{{ $t('debtInfo.table.term') }}</b></th>
                            <th scope="col"><b>{{ $t('debtInfo.table.interestRate') }}</b></th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <th scope="row">ORI269A</th>
                            <td class="text-center">714.7</td>
                            <td class="text-center">714.7</td>
                            <td class="text-center">{{ formatDate('2022-09-01') }}</td>
                            <td class="text-center">{{ formatDate('2026-09-01') }}</td>
                            <td class="text-center">4 {{ $t('latestDocuments.year') }}</td>
                            <td class="text-center">4.25%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI259A</th>
                            <td class="text-center">982.2</td>
                            <td class="text-center">982.2</td>
                            <td class="text-center">{{ formatDate('2022-09-01') }}</td>
                            <td class="text-center">{{ formatDate('2025-09-01') }}</td>
                            <td class="text-center">3 {{ $t('latestDocuments.year') }}</td>
                            <td class="text-center">3.95%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI273A</th>
                            <td class="text-center">700.0</td>
                            <td class="text-center">700.0</td>
                            <td class="text-center">{{ formatDate('2023-03-22') }}</td>
                            <td class="text-center">{{ formatDate('2027-03-22') }}</td>
                            <td class="text-center">4 {{ $t('latestDocuments.year') }}</td>
                            <td class="text-center">4.45%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI263A</th>
                            <td class="text-center">1,200.0</td>
                            <td class="text-center">1,200.0</td>
                            <td class="text-center">{{ formatDate('2023-03-22') }}</td>
                            <td class="text-center">{{ formatDate('2026-03-22') }}</td>
                            <td class="text-center">3 {{ $t('latestDocuments.year') }}</td>
                            <td class="text-center">4.15%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI277A</th>
                            <td class="text-center">955.6</td>
                            <td class="text-center">955.6</td>
                            <td class="text-center">{{ formatDate('2023-07-11') }}</td>
                            <td class="text-center">{{ formatDate('2027-07-11') }}</td>
                            <td class="text-center">4 {{ $t('latestDocuments.year') }}</td>
                            <td class="text-center">4.60%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI267A</th>
                            <td class="text-center">2,067.9</td>
                            <td class="text-center">2,067.9</td>
                            <td class="text-center">{{ formatDate('2023-07-11') }}</td>
                            <td class="text-center">{{ formatDate('2026-07-11') }}</td>
                            <td class="text-center">3 {{ $t('latestDocuments.year') }}</td>
                            <td class="text-center">4.40%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI271A</th>
                            <td class="text-center">780.5</td>
                            <td class="text-center">780.5</td>
                            <td class="text-center">{{ formatDate('2024-01-16') }}</td>
                            <td class="text-center">{{ formatDate('2027-01-16') }}</td>
                            <td class="text-center">3 {{ $t('latestDocuments.year') }}</td>
                            <td class="text-center">4.85%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI259B</th>
                            <td class="text-center">1,000.0</td>
                            <td class="text-center">1,000.0</td>
                            <td class="text-center">{{ formatDate('2024-01-16') }}</td>
                            <td class="text-center">{{ formatDate('2025-09-01') }}</td>
                            <td class="text-center">1.63 {{ $t('latestDocuments.year') }}</td>
                            <td class="text-center">4.25%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI27NA</th>
                            <td class="text-center">623.3</td>
                            <td class="text-center">623.3</td>
                            <td class="text-center">{{ formatDate('2024-05-14') }}</td>
                            <td class="text-center">{{ formatDate('2027-11-14') }}</td>
                            <td class="text-center">3.5 {{ $t('latestDocuments.year') }}</td>
                            <td class="text-center">5.00%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI275A</th>
                            <td class="text-center">941.7</td>
                            <td class="text-center">941.7</td>
                            <td class="text-center">{{ formatDate('2024-05-14') }}</td>
                            <td class="text-center">{{ formatDate('2027-05-14') }}</td>
                            <td class="text-center">3 {{ $t('latestDocuments.year') }}</td>
                            <td class="text-center">4.85%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI263B</th>
                            <td class="text-center">935.0</td>
                            <td class="text-center">935.0</td>
                            <td class="text-center">{{ formatDate('2024-05-14') }}</td>
                            <td class="text-center">{{ formatDate('2026-03-22') }}</td>
                            <td class="text-center">1.85 {{ $t('latestDocuments.year') }}</td>
                            <td class="text-center">4.25%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI288A</th>
                            <td class="text-center">454.9</td>
                            <td class="text-center">454.9</td>
                            <td class="text-center">{{ formatDate('2024-08-09') }}</td>
                            <td class="text-center">{{ formatDate('2028-08-09') }}</td>
                            <td class="text-center">4 {{ $t('latestDocuments.year') }}</td>
                            <td class="text-center">5.15%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI282A</th>
                            <td class="text-center">430.3</td>
                            <td class="text-center">430.3</td>
                            <td class="text-center">{{ formatDate('2024-08-09') }}</td>
                            <td class="text-center">{{ formatDate('2028-02-09') }}</td>
                            <td class="text-center">3.5 {{ $t('latestDocuments.year') }}</td>
                            <td class="text-center">5.00%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI278A</th>
                            <td class="text-center">317.4</td>
                            <td class="text-center">317.4</td>
                            <td class="text-center">{{ formatDate('2024-08-09') }}</td>
                            <td class="text-center">{{ formatDate('2027-08-09') }}</td>
                            <td class="text-center">3 {{ $t('latestDocuments.year') }}</td>
                            <td class="text-center">4.85%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI292A</th>
                            <td class="text-center">671.9</td>
                            <td class="text-center">671.9</td>
                            <td class="text-center">{{ formatDate('2025-02-14') }}</td>
                            <td class="text-center">{{ formatDate('2029-02-14') }}</td>
                            <td class="text-center">4 {{ $t('latestDocuments.year') }}</td>
                            <td class="text-center">5.15%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI282B</th>
                            <td class="text-center">373.7</td>
                            <td class="text-center">373.7</td>
                            <td class="text-center">{{ formatDate('2025-02-14') }}</td>
                            <td class="text-center">{{ formatDate('2028-02-14') }}</td>
                            <td class="text-center">3 {{ $t('latestDocuments.year') }}</td>
                            <td class="text-center">4.85%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI273B</th>
                            <td class="text-center">454.4</td>
                            <td class="text-center">454.4</td>
                            <td class="text-center">{{ formatDate('2025-02-14') }}</td>
                            <td class="text-center">{{ formatDate('2027-03-22') }}</td>
                            <td class="text-center">2.1 {{ $t('latestDocuments.year') }}</td>
                            <td class="text-center">4.50%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI284B</th>
                            <td class="text-center">222.7</td>
                            <td class="text-center">222.7</td>
                            <td class="text-center">{{ formatDate('2025-04-11') }}</td>
                            <td class="text-center">{{ formatDate('2028-04-11') }}</td>
                            <td class="text-center">3 {{ $t('latestDocuments.year') }}</td>
                            <td class="text-center">5.20%</td>
                        </tr>
                        <tr>
                            <th scope="row">ORI294B</th>
                            <td class="text-center">259.3</td>
                            <td class="text-center">259.3</td>
                            <td class="text-center">{{ formatDate('2025-04-11') }}</td>
                            <td class="text-center">{{ formatDate('2029-04-11') }}</td>
                            <td class="text-center">4 {{ $t('latestDocuments.year') }}</td>
                            <td class="text-center">5.50%</td>
                        </tr>

                        <!-- รวมยอด -->
                        <tr>
                            <th scope="row"><b>{{ $t('debtInfo.table.total') }}</b></th>
                            <td class="text-center"><b>14,085.5</b></td>
                            <td class="text-center"><b>14,085.5</b></td>
                            <td class="text-center"></td>
                            <td class="text-center"></td>
                            <td class="text-center"></td>
                            <td class="text-center"></td>
                        </tr>
                    </tbody>

                </table>
            </div>
        </div>
    </div>
</template>
  
<script>
import DebtInfoTabMenu from '@/components/DebtInfoTabMenu.vue';

export default {
    name: 'Info',
    components: {
        DebtInfoTabMenu,
    },
    data() {
        return {
            currentLang: this.$i18n.locale || 'th'
        };
    },
    methods: {
        formatDate(dateStr) {
            if (!dateStr) return '';
            const date = new Date(dateStr);
            const monthsTH = [
                'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
                'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
            ];
            const day = date.getDate();
            const month = monthsTH[date.getMonth()];
            const year = this.currentLang === 'th' ? date.getFullYear() + 543 : date.getFullYear();

            return this.currentLang === 'th'
                ? `${day} ${month} ${year}`
                : date.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
        }
    },
    watch: {
        '$i18n.locale'(newLocale) {
            this.currentLang = newLocale;
        }
    }



};
</script>
<style scoped>
th {
    font-weight: normal;
}

.table {
    margin-bottom: 0;
}

.table th {
    font-size: 0.85rem;
    font-weight: normal;
    padding: 8px;
}
</style>
  